(function () {
  'use strict';
  if (window.__YF_NATIVE_DB_LOADER_V1__) return;
  window.__YF_NATIVE_DB_LOADER_V1__ = true;

  var cfg = window.YF_NATIVE_DB || {};
  var loadPromise = null;
  var scriptPromise = null;
  var cssPromise = null;
  var cssReady = false;
  var equipmentReplayPending = false;
  var pendingEquipmentButton = null;

  function loadCSS() {
    if (cssPromise) return cssPromise;
    if (!cfg.cssUrl) return Promise.reject(new Error('YF native DB CSS URL is missing'));
    var existingLinks = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < existingLinks.length; i++) {
      if (existingLinks[i].href === cfg.cssUrl || existingLinks[i].href.indexOf('yf-native-full-db.css') !== -1) {
        cssReady = true;
        return Promise.resolve();
      }
    }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cfg.cssUrl;
    link.media = 'print';
    link.setAttribute('data-yf-native-db-css', 'true');
    cssPromise = new Promise(function (resolve, reject) {
      link.onload = function () {
        link.media = 'all';
        cssReady = true;
        resolve();
      };
      link.onerror = function () {
        link.remove();
        cssPromise = null;
        reject(new Error('Could not load YF native database styles'));
      };
    });
    document.head.appendChild(link);
    return cssPromise;
  }

  function loadScript() {
    if (window.YFSearchDB) return Promise.resolve(window.YFSearchDB);
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise(function (resolve, reject) {
      if (!cfg.scriptUrl) {
        reject(new Error('YF native DB script URL is missing'));
        return;
      }
      var script = document.createElement('script');
      script.src = cfg.scriptUrl;
      script.async = true;
      script.setAttribute('data-yf-native-db-script', 'true');
      script.onload = function () {
        if (window.YFSearchDB) resolve(window.YFSearchDB);
        else {
          script.remove();
          reject(new Error('YF native database did not initialize'));
        }
      };
      script.onerror = function () {
        script.remove();
        reject(new Error('Could not load YF native database'));
      };
      document.head.appendChild(script);
    }).catch(function (error) {
      scriptPromise = null;
      throw error;
    });
    return scriptPromise;
  }

  function load() {
    if (loadPromise) return loadPromise;
    loadPromise = Promise.all([loadCSS(), loadScript()]).then(function () {
      return window.YFSearchDB;
    }).catch(function (error) {
      loadPromise = null;
      throw error;
    });
    return loadPromise;
  }

  window.YFNativeDBLoad = load;

  function idleLoad(timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () { load().catch(function () {}); }, { timeout: timeout || 1500 });
    } else {
      window.setTimeout(function () { load().catch(function () {}); }, Math.min(timeout || 1500, 900));
    }
  }

  function has(selector) {
    try { return !!document.querySelector(selector); } catch (e) { return false; }
  }

  function scheduleForPage() {
    var path = window.location.pathname || '';
    var isNativeResultsPage = /\/search\/?$/i.test(path) || has('[data-yf-native-app]');
    var hasBelowFoldDatabaseUI = has('[data-yf-product-fitment], [data-yf-product-part-info], [data-yf-category-widget], [data-yf-product-compat]');

    if (isNativeResultsPage) {
      // Let critical theme content paint first, then initialize database results almost immediately.
      requestAnimationFrame(function () {
        window.setTimeout(function () { load().catch(function () {}); }, 60);
      });
    } else if (hasBelowFoldDatabaseUI) {
      // Product/category intelligence sits below the primary product/collection content.
      // Wait until the window load event so its 269 KB bundle + database CSS cannot
      // steal bandwidth from the LCP image. Any direct user interaction loads it sooner.
      var loadBelowFoldUI = function () { idleLoad(2200); };
      if (document.readyState === 'complete') loadBelowFoldUI();
      else window.addEventListener('load', loadBelowFoldUI, { once: true });
    }
  }

  function isSearchInteraction(target) {
    return !!(target && target.closest && target.closest('[data-yf-native-search]'));
  }

  function isDatabaseInteraction(target) {
    return !!(target && target.closest && target.closest('[data-yf-my-equipment-open], [data-yf-product-fitment], [data-yf-product-part-info], [data-yf-category-widget]'));
  }

  ['pointerdown', 'focusin', 'touchstart', 'input'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (isSearchInteraction(event.target) || isDatabaseInteraction(event.target)) {
        load().catch(function () {});
      }
    }, { capture: true, passive: true });
  });

  // If someone taps My Equipment before the native DB bundle finishes downloading,
  // replay that one click after the bundle is ready so the first interaction still works.
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('[data-yf-my-equipment-open]');
    if (!button || (window.YFSearchDB && cssReady) || button.__yfReplayClick) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    pendingEquipmentButton = button;
    if (equipmentReplayPending) return;
    equipmentReplayPending = true;
    load().then(function () {
      var button = pendingEquipmentButton;
      pendingEquipmentButton = null;
      equipmentReplayPending = false;
      if (!button || !button.isConnected) return;
      button.__yfReplayClick = true;
      try { button.click(); }
      finally { button.__yfReplayClick = false; }
    }).catch(function () {
      pendingEquipmentButton = null;
      equipmentReplayPending = false;
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleForPage, { once: true });
  } else {
    scheduleForPage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event && event.target;
    if (scope && scope.querySelector && scope.querySelector('[data-yf-native-app], [data-yf-product-fitment], [data-yf-product-part-info], [data-yf-category-widget]')) {
      load().catch(function () {});
    }
  });
})();
